import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../LoginContainer/styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Divider from 'srcReact/components/common2/Divider'
import { useTranslation } from 'react-i18next'
import Link from 'react-router-dom/Link'
import { TextBox } from '../../../components/common2/TextBox'
import { isEmail } from 'srcReact/helpers/validator'
import PasswordTextBox from 'srcReact/components/common2/PasswordTextBox'
import Checkbox from 'srcReact/components/common2/Checkbox'
import { useDispatch } from 'react-redux'
import { loginActions } from 'srcReact/LoginPage/actions'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import Spinner from 'srcReact/components/common2/Spinner'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function Password({
  currentState,
  setCurrentState,
  setCurrentStep,
  passwordResetLinkSentLoading,
  passwordResetLinkError,
  passwordResetLinkErrorMessage,
  passwordResetLinkSent,
  triggeredAction,
  error,
  loading,
  firstname
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [passwordRef, setPasswordRef] = useState(null)
  const [password, setPassword] = useState({
    name: 'password',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    if (passwordRef) {
      passwordRef.current.focus()
    }
  }, [passwordRef])

  const handleTextChange = (event) => {
    if (event) {
      const { value } = event.target
      setPassword({ ...password, value: value })
    }
  }

  const handleCancel = () => {
    if (currentState.selectedOrgId && currentState.selectedOrgId > 0) {
      setCurrentStep('org-selection')
    } else {
      setCurrentStep('email')
    }
  }

  const validate = (value) => {
    setPassword({
      ...password,
      hasError: !value,
      errorMessage: !value ? t('error.required', { field: t(`global.password`) }) : ''
    })

    return value ? true : false
  }

  const handleNext = (e) => {
    e.preventDefault()
    const isValid = validate(password.value)
    if (isValid) {
      if (currentState && setCurrentState) {
        setCurrentState({ ...currentState, password: password.value })

        const { email, keepLoggedIn, selectedOrgId } = currentState

        if (email && password) {
          dispatch(loginActions.login(email, password.value, selectedOrgId, '', keepLoggedIn, triggeredAction))
        }
      }
    }
  }

  const handleCheckboxChange = () => {
    setCurrentState({
      ...currentState,
      keepLoggedIn: !currentState.keepLoggedIn
    })
  }

  const sendPasswordResetLink = () => {
    dispatch(authenticationActions.sendPasswordResetLink(currentState.email))
  }

  return (
    <div className={styles.passwordContainer}>
      <h1 className={parentStyles.title}>{t('login.password.title', { name: firstname || '' })}</h1>
      <h2 className={parentStyles.subTitle}>{t('login.password.subTitle')}</h2>
      <form className={styles.form} onSubmit={handleNext}>
        {/* <ErrorMessage text={error} className={styles.error} /> */}
        <PasswordTextBox
          label={t('formlabel.enterPswd')}
          value={password.value}
          placeholder={t('global.password')}
          handleChange={handleTextChange}
          className={styles.passwordWrapper}
          direction='column'
          isRequired={true}
          errorMessage={password.errorMessage}
          setRef={setPasswordRef}
        />

        <div className={styles.keeploggedin}>
          <Checkbox
            customClassName={styles.checkBoxAgree}
            checked={currentState.keepLoggedIn}
            name='keepLoggedIn'
            onChange={handleCheckboxChange}
          />
          <span className={styles.text}>{t('login.keepLoggedIn')}</span>
        </div>

        {error && (
          <ErrorMessage className={styles.error}>
            {t('login.incorrectPassword')} <span onClick={sendPasswordResetLink}>{t('login.forgotPassword2')}</span>
          </ErrorMessage>
        )}

        <div className={`${parentStyles.buttons} ${styles.buttons}`}>
          <Button text={t('global.back')} style='secondary' handleClick={handleCancel} />
          <Button text={t('global.signin')} type='submit' customStyle={styles.signin} />
          {loading && <Spinner customCss={styles.spinner} />}
        </div>
      </form>
      <button type='button' className={styles.loginForgetPassword} onClick={sendPasswordResetLink}>
        {t('login.forgotPassword')}
      </button>
      {passwordResetLinkSentLoading && <Spinner />}

      {passwordResetLinkError && passwordResetLinkErrorMessage.length > 0 ? (
        <div className={styles.errorSend}>{passwordResetLinkErrorMessage}</div>
      ) : passwordResetLinkSent ? (
        <div className={styles.successPswdLink}>{t('login.passwordlinkSentMessage')}</div>
      ) : null}
    </div>
  )
}

export default Password
